// counter.actions.ts
import { Action } from '@ngrx/store';
import { Users } from '../models/users.model';

export const FETCH_USERS = '[Users] FETCH_USERS';
export const FETCH_USERS_SUCCESS = '[Users] FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = '[Users] FETCH_USERS_FAILURE';

export const ADD_USER = '[Users] ADD_USER';
export const ADD_USER_SUCCESS = '[Users] ADD_USER_SUCCESS';
export const ADD_USER_FAILURE = '[Users] ADD_USER_FAILURE';

export const DELETE_USER = '[Users] DELETE_USER';
export const DELETE_USER_SUCCESS = '[Users] DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = '[Users] DELETE_USER_FAILURE';

export class FetchUsers implements Action {
  readonly type = FETCH_USERS;
  constructor() { }
}

export class FetchUsersSuccess implements Action {
  readonly type = FETCH_USERS_SUCCESS;
  constructor(public payload: any) { }
}

export class FetchUsersFailure implements Action {
  readonly type = FETCH_USERS_FAILURE;
  constructor(public payload: any) { }
}

export class AddUser implements Action {
  readonly type = ADD_USER;
  constructor(public payload: any) { }
}

export class AddUserSuccess implements Action {
  readonly type = ADD_USER_SUCCESS;
  constructor(public payload: any) { }
}

export class AddUserFailure implements Action {
  readonly type = ADD_USER_FAILURE;
  constructor(public payload: any) { }
}

export class DeleteUser implements Action {
  readonly type = DELETE_USER;
  constructor(public payload: any) { }
}

export class DeleteUserSuccess implements Action {
  readonly type = DELETE_USER_SUCCESS;
  constructor(public payload: any) { }
}

export class DeleteUserFailure implements Action {
  readonly type = DELETE_USER_FAILURE;
  constructor(public payload: any) { }
}

export type Actions = FetchUsers | FetchUsersSuccess | FetchUsersFailure
| AddUser | AddUserSuccess | AddUserFailure
| DeleteUser | DeleteUserSuccess | DeleteUserFailure



// WEBPACK FOOTER //
// ./src/actions/users.actions.ts